export const styles = theme => ({
    header: {
        height: 113,
        backgroundSize: "cover",
        position: "relative" as const,
        marginBottom: 45,
        fontSize: 34,
        "& h1": {
            margin: "0 20px",
            position: "absolute" as const,
            top: "30%",
            color: "white",
        }
    },
    public: {
        backgroundImage: "url('/images/banner/getty_small.jpg')",
    },
    account: {
        backgroundImage: "url('/images/banner/account_small.jpg')",
    },
});
